export default __webpack_public_path__ + "static/media/policy_en.3439d804.pdf";